import { useState } from "react";
import { Checkbox } from "antd";
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import {
  DocumentoLegal,
  POLITICAS_DE_USO,
  TERMINOS_Y_CONDICIONES,
} from "../../../config/documentosLegales";

interface IProps {
  aceptado: boolean;
  alCambiar: (aceptado: boolean) => void;
}

/**
 * La aceptación de las políticas y los términos, al final del último paso.
 *
 * Estaba dentro del formulario de datos personales del primer paso, y ahí no
 * servía de nada: en el wizard los datos se guardan solos y el guardado que
 * la exigía quedó sin botón, así que se podía inscribir sin aceptar nada.
 *
 * Ahora está junto al botón de inscribir, que es el momento en que se
 * declara, y sin ella la inscripción no pasa. Al estar en un solo sitio
 * aplica igual a los tres perfiles: en el de persona jurídica era un Radio
 * suelto, que una vez marcado ya no se podía desmarcar.
 */
export const AceptacionLegal = ({ aceptado, alCambiar }: IProps) => {
  const [documento, setDocumento] = useState<DocumentoLegal>(POLITICAS_DE_USO);
  const [abierto, setAbierto] = useState(false);

  const abrir = (cual: DocumentoLegal) => {
    setDocumento(cual);
    setAbierto(true);
  };

  return (
    <>
      <Checkbox
        checked={aceptado}
        onChange={(e) => alCambiar(e.target.checked)}
        className="font-family-Montserrat-Regular"
      >
        <span className="font-size-12px">
          Acepto las{" "}
          <button
            type="button"
            className="enlace-en-texto no-margin font-color-051923bf font-size-12px"
            onClick={() => abrir(POLITICAS_DE_USO)}
          >
            Políticas de uso
          </button>{" "}
          y los{" "}
          <button
            type="button"
            className="enlace-en-texto no-margin font-color-051923bf font-size-12px"
            onClick={() => abrir(TERMINOS_Y_CONDICIONES)}
          >
            Términos y condiciones
          </button>{" "}
          <span style={{ color: "red" }}>*</span>
        </span>
      </Checkbox>

      <ModalVisualizarDocumentos
        visualizar={abierto}
        setVisualizar={setAbierto}
        state={{ documento: documento.nombre }}
        tipoDocumento={documento.tipoDocumento}
      />
    </>
  );
};
